import { render } from "./DocumentSendEmail.vue?vue&type=template&id=d4b1b98e&scoped=true"
import script from "./DocumentSendEmail.vue?vue&type=script&lang=js"
export * from "./DocumentSendEmail.vue?vue&type=script&lang=js"

import "./DocumentSendEmail.vue?vue&type=style&index=0&id=d4b1b98e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4b1b98e"]])

export default __exports__